import { render, staticRenderFns } from "./ubutton.vue?vue&type=template&id=382dda1e&"
import script from "./ubutton.vue?vue&type=script&lang=js&"
export * from "./ubutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports